import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
@Component({
    selector: 'multisite-flag',
    template: `<i class="flag-dim" aria-hidden="true" [ngClass]="'flag-' + (country | lowercase)"></i>`,
    styleUrls: ['./multisite-flag.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteFlagComponent {
    @Input()
    country: string;
}
